import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuOn: true,
    navMinify: false,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight
  },
  mutations: {
    openNav (state) {
      state.menuOn = true;
    },
    closeNav ( state ) {
      state.menuOn = false;
    },
    updateMenu ( state, option  ) {
      state.navMinify = ( option.navMinify || false );
      state.menuOn    = ( option.menuOn    || false );
    },
    toggle ( state ){
      state.menuOn = !state.menuOn;
    },

    setWindowSize( state, option ) {
      state.windowWidth = option.width || window.innerHeight;
      state.windowHeight = option.height || window.innerHeight;
    }
  },
  actions: {
  },
  modules: {
  }
})
